// touch enabled?
addMetadataToErrors.$inject = ["$location", "localStorageService"];
checkPageLogin.$inject = ["$location", "apiService", "localStorageService", "personService", "urlRedirectHandlerService"];
checkPagePermission.$inject = ["$window", "PATH", "SIGN_IN_URL", "ADMIN_PAGES", "personService", "localStorageService", "permissionService", "$rootScope", "helperService", "urlRedirectHandlerService", "$location"];
preconnect.$inject = ["API_URL", "MICROSERVICES_URL"];
syncBrowserTabs.$inject = ["$window", "localStorageService", "PATH", "SIGN_IN_URL", "urlRedirectHandlerService", "$timeout"];
document.documentElement.className += (('ontouchstart' in document.documentElement) ? ' touch' : ' no-touch');

app
  .run(addMetadataToErrors)
  .run(checkPageLogin)
  .run(checkPagePermission)
  .run(preconnect)
  .run(syncBrowserTabs);
var pageIsLogin = false;
function addMetadataToErrors($location, localStorageService) {
  var user = localStorageService.get('userInfo');
  var url = $location.absUrl();
  var isDocsPage = url.indexOf('documentation') > -1;
  if (isDocsPage) {
    return;
  }
}

if (window && window.moment) {
  moment.suppressDeprecationWarnings = true;
}

function checkPageLogin($location, apiService, localStorageService, personService, urlRedirectHandlerService) {
  var url = $location.absUrl();
  var token = url.split('xt=')[1] || null;

  pageIsLogin = !!token;
}

/*
  TODO: refactor after introducing moving routing to frontend
*/
function checkPagePermission($window, PATH, SIGN_IN_URL, ADMIN_PAGES, personService, localStorageService, permissionService, $rootScope, helperService, urlRedirectHandlerService, $location) {
  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    var user = localStorageService.get('userInfo');
    var url = $location.absUrl();
    var isAuthenticatedPage = _.find(['signin', 'signup', 'password'], function (name) {
      return url.indexOf(name) > -1;
    });
    var isIgnorablePage = !!_.find(['error', 'documentation', 'quotelink', 'quotecontact'], function (page) {
      return url.indexOf(page) > -1;
    });
    var userWasAuthenticated = user && user !== 'null';
    var redirectTo = null;
    var currentStore = null;
    var redirectFromEmail;


    if (urlRedirectHandlerService.verifyUrlAddress() && !pageIsLogin) {
      if (user && user.currentStore && user.currentStore.id !== urlRedirectHandlerService.getStoreId()) {
        if (user.availableStores.length > 1) {
          currentStore = _.find(user.availableStores, { 'id': urlRedirectHandlerService.getStoreId() });
          if (currentStore) {
            user.currentStore = currentStore;
            localStorageService.set('userInfo', user);
          } else {
            redirectTo = user.homeUrl;
          }
        } else {
          redirectTo = user.homeUrl;
        }
      } else {
        // var queryToUrl = queryBuilder(urlRedirectHandlerService.getQueryData());
        localStorageService.set('redirectFromEmail', $window.location.href);
        redirectTo = PATH.apps + SIGN_IN_URL;
        redirectToRoute(redirectTo);
      }
    }

    if (isAuthenticatedPage && !pageIsLogin) {
      if (userWasAuthenticated) redirectTo = user.homeUrl;
    } else if (!isIgnorablePage && !pageIsLogin) {
      if (!userWasAuthenticated) redirectTo = PATH.apps + SIGN_IN_URL;
      else if (!permissionService.isAllowedUrl() && !pageIsLogin) {
        redirectTo = user.homeUrl;
      }
    }

    if (toState.data && toState.data.report) {
      if (!user || !user.permittedReports || user.roleName === 'superAdmin') return;
      var report = toState.data.report;
      if (report.ids) {
        redirectTo = report.ids.some(function (id) {
          return user.permittedReports.indexOf(id) !== -1;
        }) ? null : user.homeUrl;
      }
      if (report.id) {
        if (user.permittedReports.indexOf(report.id) === -1) {
          redirectTo = user.homeUrl;
        }
      }
    }

    if (user && !user.slidenInRole && ADMIN_PAGES.indexOf(toState.name) !== -1) {
      redirectTo = user.homeUrl;
    }

    if (user && user.isSlidedInAdmin) {
      var isAdminPage = !!_.find([
        'accountmanagement',
        'taskmanagement',
        'transactionmanagement',
        'activitylog',
        'systemsettings'
      ], function (page) {
        return url.indexOf(page) > -1;
      });

      if (isAdminPage) {
        personService.slideOut(user, true);
        return;
      }
    }

    if (redirectTo) {
      redirectToRoute(redirectTo);
    }

    function redirectToRoute(redirect) {
      if (!user && localStorageService.get('redirectFromEmail')) {
        $window.location.href = redirect;
        event.preventDefault();
      }
      if (!localStorageService.get('redirectFromEmail')) {
        $window.location.href = redirect;
        event.preventDefault();
      }
    }

    function queryBuilder(location) {
      var query = '?';
      _.forIn(location, function (value, key) {
        query += key + '=' + value + '&';
      });
      return query.slice(0, -1);
    }
  });
}

// do dns lookup, handshakes, etc before first request to the server
function preconnect(API_URL, MICROSERVICES_URL) {
  [API_URL, MICROSERVICES_URL].forEach(function (url) {
    var hint = document.createElement('link');
    hint.rel = 'preconnect';
    hint.href = url;
    document.head.appendChild(hint);
  });
}

/*
  reload other tabs
  when user slides in, slides out, signs out, signs in
*/
function syncBrowserTabs($window, localStorageService, PATH, SIGN_IN_URL, urlRedirectHandlerService, $timeout) {
  var homeUrl = getHomeUrl();
  var store = getStore();

  // Listen for storage events
  angular.element($window).on('storage', function () {
    if (urlRedirectHandlerService.verifyUrlAddress()) return false;

    var newHomeUrl = getHomeUrl();
    if (newHomeUrl !== homeUrl) {
      $window.location.href = newHomeUrl || (PATH.apps + SIGN_IN_URL);
      return;
    }
    var newStore = getStore();
    if (store !== newStore) {
      $window.location.reload();
    }
  });

  function getHomeUrl() {
    var userInfo = localStorageService.get('userInfo');
    var url = userInfo && userInfo !== 'null' && userInfo.homeUrl;
    return url;
  }
  function getStore() {
    var userInfo = localStorageService.get('userInfo');
    var storeId = userInfo && userInfo !== 'null' && userInfo.currentStore && userInfo.currentStore.id;
    return storeId;
  }
}



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/run.js